import { useEffect, useState } from "react";

const useIsStuck = ({
  root = null,
  rootMargin,
}: {
  root: HTMLElement | null;
  rootMargin?: number;
}): [(el: HTMLElement) => void, boolean] => {
  const [isStuck, setStuck] = useState(false);
  const [node, setNode] = useState(null);

  useEffect(() => {
    const observer = new window.IntersectionObserver(
      ([e]) => setStuck(!e.isIntersecting),
      {
        root,
        threshold: 1.0,
      }
    );

    if (node) {
      observer.observe(node);
    }

    return () => observer.disconnect();
  }, [node, root, rootMargin]);

  return [setNode, isStuck];
};

export default useIsStuck;
